module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-33-cfb6529257de4359abc15930208c40e0.svg";